import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import csr1Png from '../assets/images/csr1.png';
import { useAuth } from '../context/useAuth';

const Navbar = ({ onToggleSidebar, onToggleMobileSidebar, theme, onToggleTheme }) => {
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <nav className="main-navbar d-flex align-items-center" role="banner" aria-label="Main header">
      {/* Desktop sidebar toggle */}
      <button 
        className="sidebar-toggle-desktop d-none d-lg-block" 
        onClick={onToggleSidebar}
        aria-label="Toggle sidebar (desktop)"
      >
        <i className="bi bi-layout-sidebar-inset" aria-hidden="true"></i>
      </button>

      {/* Mobile brand and sidebar toggle */}
      <div className="d-flex align-items-center d-lg-none">
        {/* Mobile brand logo */}
        <div className="navbar-brand-mobile d-flex align-items-center me-3">
          <span className="logo-icon" aria-label="TriServe Energy logo">
            <i className="bi bi-lightning-charge-fill" aria-hidden="true"></i>
          </span>
          <span className="brand-label ms-2 fw-bold text-primary">TriServe Energy</span>
        </div>
        
        {/* Mobile sidebar toggle */}
        <button 
          className="btn btn-link p-0" 
          onClick={onToggleMobileSidebar}
          aria-label="Toggle sidebar" 
          type="button"
        >
          <i className="bi bi-list sidebar-toggle-icon" aria-hidden="true"></i>
        </button>
      </div>

      <div className="d-flex align-items-center ms-auto">
        {/* Dark mode toggle */}
        <div 
          className="darkmode-toggle" 
          tabIndex="0" 
          role="button" 
          aria-pressed={theme === 'dark'}
          aria-label="Toggle light or dark theme"
          onClick={onToggleTheme}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              onToggleTheme();
            }
          }}
        >
          <i className={`bi bi-${theme === 'dark' ? 'sun' : 'moon'}`} aria-hidden="true"></i>
        </div>

        {/* User profile dropdown */}
        <div className="dropdown">
          <button 
            className="btn btn-link d-flex align-items-center dropdown-toggle p-0" 
            type="button" 
            id="profileDropdown" 
            data-bs-toggle="dropdown" 
            aria-expanded="false"
            aria-label="User profile menu - Customer Service Representative"
            aria-haspopup="true"
          >
            <img 
              src={csr1Png}
              className="rounded-circle profile-pic" 
              alt="Customer Service Representative profile picture"
            />
          </button>
          <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="profileDropdown">
            <li>
              <h6 className="dropdown-header">Customer Service Rep</h6>
            </li>
            <li>
              <a className="dropdown-item" href="#">
                <i className="bi bi-person me-2" aria-hidden="true"></i>Profile
              </a>
            </li>
            <li>
              <a className="dropdown-item" href="#">
                <i className="bi bi-headset me-2" aria-hidden="true"></i>Support Tools
              </a>
            </li>
            <li>
              <a className="dropdown-item" href="#">
                <i className="bi bi-journal-text me-2" aria-hidden="true"></i>Daily Reports
              </a>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
            {isAuthenticated ? (
              <li>
                <button className="dropdown-item text-danger" type="button" onClick={handleLogout} data-testid="nav-logout">
                  <i className="bi bi-box-arrow-right me-2" aria-hidden="true"></i>Logout
                </button>
              </li>
            ) : (
              <li>
                <Link className="dropdown-item" to="/login" data-testid="nav-login">
                  <i className="bi bi-box-arrow-in-right me-2" aria-hidden="true"></i>Login
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
